import React from "react";
import * as PropTypes from "prop-types";
import FormatMessage from "../../messages/FormatMessage";
import dot from "dot-object";

class Date extends React.Component {

    static propTypes = {
        beanName: PropTypes.string,
        property: PropTypes.string,
        questionKey: PropTypes.string,
        reviewKey: PropTypes.string,
        pageid: PropTypes.string,
        required: PropTypes.string,
        errorKey: PropTypes.string,
        requireExplain: PropTypes.string,
        requireLightBox: PropTypes.string,
        requireInstructionLightBox: PropTypes.string,
        dateCompareDate: PropTypes.string,
        dateCompareFromKey: PropTypes.string,
        dateCompareToKey: PropTypes.string,
        compareDate: PropTypes.string,
        compareDateErrorKey: PropTypes.string,
        conditionalValue: PropTypes.string,
        checkValue: PropTypes.string,
        requireOptional: PropTypes.string,
        dataType: PropTypes.string,
        skipDay: PropTypes.string,
        onChange: PropTypes.func,
        instructionText: PropTypes.string,
        instructionExplain: PropTypes.string,
        linkToPageID: PropTypes.string,
        questionAdditionalInstructions: PropTypes.string,
        controlInsideRepeater: PropTypes.string,
        controlInsideDateRange: PropTypes.string,
        repeaterShowHide: PropTypes.string,
        hasLearnMoreHeader: PropTypes.string,
        hasInstructionLearnMoreHeader: PropTypes.string,
        repeaterCountKey: PropTypes.string,
        systemDate: PropTypes.string,
        startYear: PropTypes.string,
        endYear: PropTypes.string,
        value: PropTypes.string,
        checkBoxKey: PropTypes.string,
        requireCheckBox: PropTypes.string,
        onCheckBoxClick: PropTypes.string,
        checkBoxRequireExplain: PropTypes.string,
        checkBoxRequireLightBox: PropTypes.string,
        checkBoxPageId: PropTypes.string,
        state: PropTypes.string
    }
    static defaultProps = {
        beanName: '',
        property: '',
        questionKey: '',
        reviewKey: '',
        pageid: '',
        required: '',
        errorKey: '',
        requireExplain: '',
        requireLightBox: '',
        requireInstructionLightBox: '',
        dateCompareDate: '',
        dateCompareFromKey: '',
        dateCompareToKey: '',
        compareDate: '',
        compareDateErrorKey: '',
        conditionalValue: '',
        checkValue: '',
        requireOptional: '',
        dataType: '',
        skipDay: '',
        onChange: () => {
        },
        instructionText: '',
        instructionExplain: '',
        linkToPageID: '',
        questionAdditionalInstructions: '',
        controlInsideRepeater: '',
        controlInsideDateRange: '',
        repeaterShowHide: '',
        hasLearnMoreHeader: '',
        hasInstructionLearnMoreHeader: '',
        repeaterCountKey: '',
        systemDate: '',
        startYear: '',
        endYear: '',
        value: '',
        checkBoxKey: '',
        requireCheckBox: '',
        onCheckBoxClick: '',
        checkBoxRequireExplain: '',
        checkBoxRequireLightBox: '',
        checkBoxPageId: '',
        state: '',
        status: ''
    }

    constructor(props) {
        super(props);
        this.state = {
            day: "",
            month: "",
            year: "",
            checkboxVal: "",
            application: {}
        }
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.application != prevState.application) {
            return {
                application: nextProps.application,
                day: dot.pick(nextProps.property + ".day", nextProps.application.applicationData),
                month: dot.pick(nextProps.property + ".month", nextProps.application.applicationData),
                year: dot.pick(nextProps.property + ".year", nextProps.application.applicationData),
                checkboxVal: dot.pick(nextProps.property + ".checkbox", nextProps.application.applicationData)
            }
        }
        return null;
    }

    render() {
        const {
            beanName,
            property,
            questionKey,
            required,
            errorKey,
            checkBoxKey,
            requireCheckBox,
            repeaterCountKey,
            startYear,
            endYear,
            state,
            status
        } = this.props;
        var dynamicName = beanName + "-" + property.replaceAll(".", "-");
        var dynamicId = beanName + "." + property.replaceAll(".", "-");
        return (
            <div>
                {state == undefined || state == "" &&
                    <div>
                        <div className="Question">
                            <div className="Question-title">
                        <span className="Question-titleText">
                            <FormatMessage id={questionKey}/>
                        </span>
                            </div>
                        </div>
                        <div className="AnswerField set">
                            <div className="GridLayout AnswerField-mixedLayout AnswerField-mixedLayoutInline">
                                <div className="GridLayoutCell AnswerField-cell AnswerField-cellInline element">
                                    <label className="AnswerField-subLabel">
                                        <FormatMessage id="control.date.month"/>
                                    </label>
                                    <div className="SelectInput">
                                        <select name={dynamicName + "-month"}
                                                id={dynamicId + ".month"}
                                                value={this.state.month != undefined ? this.state.month : ""}
                                                onChange={(e) => this.handleDateChange(e, property + ".month")}
                                                data-msg-required={errorKey != "" ? errorKey : "control.text.mandatoryerror"}
                                                data-rule-required={required}>
                                            <option value=""></option>
                                            <FormatMessage id="control.date.january">{(message) =>
                                                <option value="Jan">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.february">{(message) =>
                                                <option value="Feb">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.march">{(message) =>
                                                <option value="Mar">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.april">{(message) =>
                                                <option value="Apr">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.may">{(message) =>
                                                <option value="May">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.june">{(message) =>
                                                <option value="Jun">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.july">{(message) =>
                                                <option value="Jul">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.august">{(message) =>
                                                <option value="Aug">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.september">{(message) =>
                                                <option value="Sep">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.october">{(message) =>
                                                <option value="Oct">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.november">{(message) =>
                                                <option value="Nov">{message}</option>}
                                            </FormatMessage>
                                            <FormatMessage id="control.date.december">{(message) =>
                                                <option value="Dec">{message}</option>}
                                            </FormatMessage>
                                        </select>
                                    </div>
                                </div>
                                <div className="GridLayoutCell AnswerField-cell AnswerField-cellInline element">
                                    <label className="AnswerField-subLabel">
                                        <FormatMessage id="control.date.day"/>
                                    </label>
                                    <div className="SelectInput">
                                        <select name={dynamicName + "-day"}
                                                id={dynamicId + ".day"}
                                                value={this.state.day != undefined ? this.state.day : ""}
                                                onChange={(e) => this.handleDateChange(e, property + ".day")}
                                                data-msg-required={errorKey != "" ? errorKey : "control.text.mandatoryerror"}
                                                data-rule-required={required}>
                                            <option value=""></option>
                                            {[...Array(31)].map((x, i) =>
                                                <option value={i + 1} key={i}>{i + 1}</option>
                                            )}
                                        </select>
                                    </div>
                                </div>
                                <div className="GridLayoutCell AnswerField-cell AnswerField-cellInline element">
                                    <label className="AnswerField-subLabel">
                                        <FormatMessage id="control.date.year"/>(YYYY)
                                    </label>
                                    <div className="TextInput">
                                        <input type="text" name={dynamicName + "-year"}
                                               value={this.state.year != undefined ? this.state.year : ""}
                                               id={dynamicId + ".year"}
                                               onChange={(e) => this.handleDateChange(e, property + ".year")}
                                               data-msg-required={errorKey != "" ? errorKey : "control.text.mandatoryerror"}
                                               data-rule-required={required}
                                               data-dependent-attribute-start-year={startYear}
                                               data-dependent-attribute-end-year={endYear}
                                               data-dependent-attribute-month={dynamicName + "-month"}
                                               data-dependent-attribute-day={dynamicName + "-day"}
                                               data-msg-date="control.date.invaliderror"
                                               data-rule-date="true"
                                               size="8"
                                               maxLength="4"/>
                                    </div>
                                </div>
                            </div>
                            {requireCheckBox != "" &&
                                <div
                                    className="GridLayoutCell AnswerField-cell AnswerField-cellAlignWithSubLabeledInputs element">
                                    <div className="CheckboxInput CheckboxInput-smallLabel">
                                        <input type="checkbox" className="CheckboxInput-input"
                                               id={dynamicId + ".checkbox"}
                                               name={dynamicName + "-checkbox"}
                                               checked={this.state.checkboxVal != undefined ? this.state.checkboxVal : false}
                                               onChange={(e) => this.handleDateChange(e, property + ".checkbox")}/>
                                        <label className="CheckboxInput-label ${beanName}-${property}-unknown-label">
                                            <FormatMessage id={checkBoxKey}/>
                                        </label>
                                    </div>
                                </div>
                            }
                            <p className="AnswerField-errorMessage"></p>
                        </div>
                    </div>
                }
                {state != undefined && state == "output" &&
                    <div>
                        {this.props.repeaterIndex != undefined ?
                            <div>
                                <div className="ReviewSection-elementRepeaterHeader">
                                    <span className="ReviewSection-elementRepeaterHeaderLabel">
                                        <FormatMessage id={repeaterCountKey}/> {this.props.repeaterIndex + 1}
                                    </span>
                                </div>
                                <div className="ReviewSection-elementRepeaterMain">
                                    <div className="ReviewSection-elementRepeaterField">
                                        {!required ?
                                            <div
                                                className="ReviewSection-elementRepeaterAnswer ReviewSection-answerLabelOptional">
                                                <FormatMessage id="message.optionfield"/>
                                            </div> :
                                            status == "incomplete" ?
                                                <div className="ReviewSection-elementRepeaterAnswer">
                                                    <div className="ReviewAnswerStatus ReviewAnswerStatus-incomplete">
                                                <span className="ReviewAnswerStatus-label">
                                                    <FormatMessage id="application.sectionreview.incomplete"/>
                                                </span>
                                                    </div>
                                                </div> :
                                                <div className="ReviewSection-elementRepeaterAnswer">
                                                    {this.state.month != undefined && this.state.month != "" ? this.state.month + " " : ""}
                                                    {this.state.day != undefined && this.state.day != "" ? this.state.day + ", " : ""}
                                                    {this.state.year != undefined && this.state.year != "" ? this.state.year + " " : ""}
                                                </div>
                                        }
                                    </div>
                                </div>
                            </div> :
                            !required ?
                                <div className="ReviewSection-answerLabelOptional">
                                    <FormatMessage id="message.optionfield"/>
                                </div> :
                                status == "incomplete" ?
                                    <div className="ReviewAnswerStatus ReviewAnswerStatus-incomplete">
                                        <span className="ReviewAnswerStatus-label">
                                            <FormatMessage id="application.sectionreview.incomplete"/>
                                        </span>
                                    </div> :
                                    <div className="ReviewSection-answer">
                                        <span className="ReviewSection-answerLabel">
                                            {this.state.month != undefined && this.state.month != "" ? this.state.month + " " : ""}
                                            {this.state.day != undefined && this.state.day != "" ? this.state.day + ", " : ""}
                                            {this.state.year != undefined && this.state.year != "" ? this.state.year + " " : ""}
                                        </span>
                                    </div>
                        }
                    </div>
                }
            </div>
        );
    }

    handleDateChange(event, property) {
        let value = event.target.value
        const applicationData = this.state.application.applicationData;
        applicationData[property] = value
        let day = this.state.day != undefined ? this.state.day : ""
        let month = this.state.month != undefined ? this.state.month : ""
        let year = this.state.year != undefined ? this.state.year : ""
        if (property.includes(".day")) {
            if (month == "") {
                applicationData[this.props.property + ".month"] = ""
            }
            if (year == "") {
                applicationData[this.props.property + ".year"] = ""
            }
            this.setState({
                day: value
            })
        } else if (property.includes(".month")) {
            if (day == "") {
                applicationData[this.props.property + ".day"] = ""
            }
            if (year == "") {
                applicationData[this.props.property + ".year"] = ""
            }
            this.setState({
                month: value
            })
        } else if (property.includes(".year")) {
            if (day == "") {
                applicationData[this.props.property + ".day"] = ""
            }
            if (month == "") {
                applicationData[this.props.property + ".month"] = ""
            }
            this.setState({
                year: value
            })
        }
        dot.object(applicationData);
        this.props.dispatchApplicationData(applicationData)
    }
}

export default Date;
